<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-overlay :show="loading" rounded="sm">
                            <localization :language="kendoLang">
                                <intl :locale="kendoLang">
                                    <Grid ref="grid" :data-items="gridData" :resizable="true" :reorderable="true"
                                        :sortable="true" :pageable="gridPageable" :groupable="true" :group="group"
                                        :sort="sort" :filter="filter" :take="take" :skip="skip" :columns="columns"
                                        :column-menu="columnMenu" :selectable="true" :selected-field="selectedField"
                                        @headerselectionchange="onHeaderSelectionChange" @datastatechange="dataStateChange"
                                        @selectionchange="onSelectionChange">

                                        <template v-slot:refTemplate="{ props }">
                                            <td v-if="props.rowType !== 'groupHeader'">
                                                <router-link class="pl-0 no-router-link-exact-active"
                                                    :to='"/orderHistory/detail/" + props.dataItem.eventSid'
                                                    v-b-toggle="'orderHistoryRightpopup'" v-bind:t_label="'EMPBE_OrderHistory_OpenDetail_' + props.dataItem.eventSid">
                                                    {{ props.dataItem.eventSid }}
                                                </router-link>
                                            </td>

                                        </template>
                                        <template v-slot:itemTemplate="{ props }">
                                            <td v-if="props.rowType !== 'groupHeader'">
                                                <div v-for="item in props.dataItem.item ">
                                                    {{ langid == '1252' ? item.titleEn : langid == '950' ? item.titleTc :
                                                        item.titleSc }} x {{ item.qty }}
                                                </div>
                                            </td>
                                        </template>
                                        <template v-slot:amountTemplate="{ props }">
                                            <td v-if="props.rowType !== 'groupHeader'">
                                                {{ props.dataItem.currency == 840 ? 'USD$' : 'RMB¥' }}
                                                {{ props.dataItem.amount }}
                                            </td>
                                        </template>
                                        <template v-slot:TitleTemplate="{ props }">
                                            <td v-if="props.rowType !== 'groupHeader'">
                                                {{ props.dataItem.emailSubject }}<br />
                                            </td>
                                        </template>
                                    </Grid>
                                </intl>
                            </localization>

                        </b-overlay>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { PaymentItemService } from '../../_services';

import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { process } from '@progress/kendo-data-query';
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-vue-intl';

export default {
    components: {
        Grid: Grid,
        toolbar: GridToolbar,
        localization: LocalizationProvider,
        intl: IntlProvider
    },
    data() {
        return {
            loading: false,
            error: null,
            totalRows: 1,
            currentPage: 1,
            items: [],
            filter: null,
            gridData: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            rowSelected: [],
            skip: 0,
            take: 10,
            group: [],
            sort: [],
            filter: null,
            gridPageable: {
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
            },
            searchWord: '',
            selectedField: 'selected',
            columnMenu: true,
        };
    },
    created() {
        this.gridData = this.getData(this.items);
    },
    computed: {
        langid() {
            return localStorage.getItem("currentLangId")
        },
        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key };
                });
        },
        selectedDataItems() {
            return this.gridData.data.filter((item) => item.selected === true);
        },
        areAllSelected() {
            return (
                this.selectedDataItems.length === this.gridData.data.length &&
                this.selectedDataItems.length !== 0
            );
        },
        columns() {
            return [

                { field: 'ref', title: this.$t("lbl_EMPBE_TransactionId"), cell: 'refTemplate' },
                { field: 'ref', title: this.$t("lbl_EMPBE_Product"), cell: 'itemTemplate' },
                { field: 'payDate', title: this.$t("lbl_EMPBE_PayDate"), filter: 'date', format: '{0:D}' },
                { field: 'amount', title: this.$t("lbl_EMPBE_Price"), cell: 'amountTemplate' },


            ];
        },
        kendoLang() {
            var langid = localStorage.getItem("currentLangId");
            switch (langid) {
                case "1252":
                    return "en-US";
                case "950":
                    return "zh-Hant";
                case "936":
                    return "zh-Hans";
                default:
                    return "zh-Hans";
            }
        }
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.items.length;
        this.LoadOrderData();
    },

    methods: {
        LoadOrderData() {
            var that = this;
            PaymentItemService.GetPaymentHistory().then(res => {
                var data = res;
                data = data.reduce(function (result, current) {
                    var curRes = result.filter((x) => x.ref == current.ref);
                    if (curRes.length > 0) {
                        curRes[0].item.push(current)
                    } else {
                        result.push({ ...current, item: [current] });
                    }
                    // result.push()
                    // result[current.ref] = result[current.ref] || [];
                    // result[current.ref].push(current);
                    return result;
                }, [])
                console.log(data)
                that.items = data;
                that.totalRows = that.items.length;
                that.gridData = that.getData(that.items);
            })
        },
        onSelectionChange(event) {
            event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
        },
        handleFilterChange: function (ev) {
            this.filter = ev.filter;

            this.gridData = this.getData(this.items);
        },
        createAppState: function (dataState) {
            this.group = dataState.group;
            this.take = dataState.take;
            this.skip = dataState.skip;
            this.sort = dataState.sort;
            this.filter = dataState.filter;

            this.gridData = this.getData(this.items);
        },
        dataStateChange: function (event) {
            this.createAppState(event.data);
        },
        getData(data) {
            return process(data, {
                take: this.take,
                skip: this.skip,
                group: this.group,
                sort: this.sort,
                filter: this.filter,
            });
        },
        onHeaderSelectionChange(event) {
            let checked = event.event.target.checked;
            const tempData = this.items.map((item) => {
                return { ...item, selected: checked };
            });

            const tempGridData = this.gridData.data.map((item) => {
                return { ...item, selected: checked };
            });
            this.gridData.data = tempGridData;
            this.items = tempData;
        },
        getEmailSubject(item) {
            if (item.FormType == "getQuotation") {
                var replaceText = this.langid == '1252' ? item.exhibitNameE : this.langid == '950' ? item.exhibitNameT : item.exhibitNameS;
                return item.emailSubject.replace(/#(\w+)#/g, replaceText);
            } else {
                var replaceText = item.buyerCompName;
                return item.emailSubject.replace(/#(\w+)#/g, replaceText);
            }
        },

    },
};
</script>